import { render, staticRenderFns } from "./Form_submit.vue?vue&type=template&id=6cba2554&scoped=true&"
import script from "./Form_submit.vue?vue&type=script&lang=js&"
export * from "./Form_submit.vue?vue&type=script&lang=js&"
import style0 from "./Form_submit.vue?vue&type=style&index=0&id=6cba2554&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba2554",
  null
  
)

export default component.exports